import { lazy, useEffect } from 'react'
import { useNavigate, useRoutes } from 'react-router-dom'
import MainLayout from '../layout/MainLayout'
import Loadable from '../layout/ui-components/Loadable'
import { useDispatch } from 'react-redux'
import Cookies from 'js-cookie'
import { logoutUser } from '../store/actions/auth'

const PageNotFound = Loadable(lazy(() => import('../views/extra/NotFound')))
const Settings = Loadable(lazy(() => import('../views/settings')))
const Website = Loadable(lazy(() => import('../views/website')))
const Revenue = Loadable(lazy(() => import('../views/revenue')))
const Support = Loadable(lazy(() => import('../views/support')))

// ==============================|| MAIN ROUTING ||============================== //

export default function MainRoutes() {
  const dispatch: any = useDispatch()
  const navigate = useNavigate()

  useEffect(() => {
    if (!Cookies.get('dot-pub-token')) {
      navigate('/')
      dispatch(logoutUser())
    }
    // eslint-disable-next-line
  }, [])

  const list = {
    path: '/',
    element: <MainLayout />,
    children: [
      { path: '/', element: <Website /> },
      { path: '/websites', element: <Website /> },
      { path: '/revenue', element: <Revenue /> },
      { path: '/settings', element: <Settings /> },
      { path: '/support', element: <Support /> },
      { path: '*', element: <PageNotFound /> }
    ]
  }
  return useRoutes([list])
}
